/**
 * WordPress dependencies
 */

export default {
	hookPrefix: 'service',
};
